export default __webpack_public_path__ + "static/media/pimeo_blue.0c6570c3.svg";